/*
Do not update image-compare-viewer to version 1.6.2. https://github.com/kylewetton/image-compare-viewer/issues/64

There is a bug on mobile devices as mentioned also in this issue

It seems the issue is present on the 1.6.2 version only, as the author stated the issue is not on the demo and that's because the demo uses the 1.5.0 version. Currently, I'm using the 1.5.0 version but I'm not sure what improvements or fixes I'm missing on the new version.
*/

// eslint-disable-next-line import/no-extraneous-dependencies
import ImageCompare from 'image-compare-viewer';
import '../../node_modules/image-compare-viewer/dist/image-compare-viewer.min.css';

class CompareBlock extends HTMLElement {
  constructor() {
    super();
    this._imageCompareInstances = [];
  }

  connectedCallback() {
    this._initImageCompare();
  }

  disconnectedCallback() {
    this._imageCompareInstances.forEach((instance) => instance.destroy());
    this._imageCompareInstances = [];
  }

  _initImageCompare() {
    const imageCompareElements = this.querySelectorAll('.compare-block');

    if (imageCompareElements.length === 0) return;

    const options = {
      // UI Theme Defaults
      controlColor: '#c39f7d',
      controlShadow: true,
      addCircle: false,
      addCircleBlur: true,

      // Label Defaults
      showLabels: false,
      labelOptions: {
        before: 'Before',
        after: 'After',
        onHover: false,
      },

      // Smoothing
      smoothing: true,
      smoothingAmount: 100,

      // Other options
      hoverStart: false,
      verticalMode: false,
      startingPoint: 50,
      fluidMode: false,
    };

    imageCompareElements.forEach((element) => {
      const beforeImage = element.querySelector('.image-compare-before');
      const afterImage = element.querySelector('.image-compare-after');

      if (!beforeImage || !afterImage) return;

      const instance = new ImageCompare(element, {
        ...options,
        before: beforeImage,
        after: afterImage,
      });

      instance.mount();
      this._imageCompareInstances.push(instance);
    });
  }
}

customElements.define('compare-block', CompareBlock);
